import React from 'react';
import { motion } from 'framer-motion';
import { education, record, site, toolbox } from '../content';
import { Reveal } from './Reveal';
import { EASE_OUT } from './motion';

export function Record() {
  const years = new Date().getFullYear() - site.since;

  return (
    <section id="record" className="record wrap">
      <div className="section-head mono">
        <span>(04)</span>
        <span>Record</span>
      </div>

      <div className="record__grid">
        <div className="record__lead">
          <p className="record__big">
            <Reveal>{years}+ years</Reveal>
            <Reveal delay={0.08}>
              <span className="serif">of shipping.</span>
            </Reveal>
          </p>
          <p className="record__sub muted">
            Full-stack, from database to pixel. Payment systems, consumer apps and developer tools,
            with a soft spot for Go, clean APIs, and interfaces that feel calm.
          </p>
          <a
            className="record__resume mono u-link"
            href={site.resume}
            target="_blank"
            rel="noopener noreferrer"
            data-cursor="PDF"
          >
            Résumé ↗
          </a>
        </div>

        <div>
          <ol className="record__list">
            {record.map((item, i) => (
              <motion.li
                key={`${item.company}-${item.role}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: EASE_OUT, delay: i * 0.06 }}
              >
                <span className="mono muted">{item.years}</span>
                <span className="record__company">{item.company}</span>
                <span className="record__role muted">{item.role}</span>
              </motion.li>
            ))}
          </ol>

          <div className="record__edu">
            <span className="mono muted">Education</span>
            <ul>
              {education.map((item) => (
                <li key={item.school}>
                  <span className="mono muted">{item.years}</span>
                  <span>{item.school}</span>
                  <span className="muted">{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="record__tools">
            <span className="mono muted">Toolbox</span>
            <ul>
              {toolbox.map((tool) => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
